import React, {
  useState
} from 'react';
import _ from 'lodash';
import { Checkbox } from '@material-ui/core';
import MinusIcon from "../../icons/MinusIcon";
import PlusIcon from "../../icons/PlusIcon";
import './style.css';
import { useSelector } from 'react-redux';
import { LIGHT_GREEN } from "../../config/colors";
import {
  getCategoryFilterColor,
  getCategoryFilterTextColor,
} from "../../selectors/configSelectors";

const CategoryFilter = (props) => {

    const [ typeExpand, setTypeExpand ] = useState(false);

    const categoryFilterColor = useSelector(getCategoryFilterColor);
    const categoryFilterTextColor = useSelector(getCategoryFilterTextColor);

    const { type } = props;

    const isTypeChecked = () => {
      const { filters } = props;
      return filters.length > 0;
    };

    const isSubtypeChecked = (subtype) => {
      const { filters } = props;
      return filters.includes(subtype);
    };

    const selectType = () => {
      const {
        subtypes,
        selectFilter
      } = props;

      if (isTypeChecked()) {
        selectFilter([])
      } else {
        selectFilter(subtypes)
      }
    };

    const selectSubtype = (subtype) => {
      const {
        selectFilter,
        filters
      } = props;

      if (isSubtypeChecked(subtype)) {
        selectFilter(filters.filter(s => s !== subtype));
      } else {
        selectFilter([...filters, subtype]);
      }
    };

    const renderSubTypes = () => {
      const {
        subtypes,
        type,
        color,
      } = props;

      if (typeExpand) {
        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {
              subtypes.map(subtype => (
                <div
                  className='clickable'
                  style={{marginLeft: 24}}
                  onClick={() => selectSubtype(subtype)}
                  key={type + subtype}
                >
                  <Checkbox
                    style={{color: color || LIGHT_GREEN}}
                    checked={isSubtypeChecked(subtype)}
                    onChange={() => selectSubtype(subtype)}
                  />
                  { subtype }
                </div>
              ))
            }
          </div>
        )
      }
      return null;
    };

    return (
      <div>
        <div
          style={{
            height: 32,
            backgroundColor: `#${categoryFilterColor}`,
            borderRadius: 4,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingRight: 12,
            marginBottom: 8,
            cursor: 'pointer',
          }}
          onClick={() => {
            setTypeExpand(!typeExpand);
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center'}}>
            <Checkbox
              style={{color: props.color || LIGHT_GREEN}}
              checked={isTypeChecked()}
              onChange={selectType}
            />
            <div
              style={{
                fontWeight: 'bold',
                color: `#${categoryFilterTextColor}`
              }}
            >
              { type }
            </div>
          </div>
          <div
            className='clickable'
            onClick={() => {
              setTypeExpand(!typeExpand);
            }}
          >
            {
              typeExpand
                ? <MinusIcon viewBox="0 0 16 16"/>
                : <PlusIcon viewBox="0 0 16 16"/>
            }
          </div>
        </div>
        {renderSubTypes()}
      </div>
    )
};

export default CategoryFilter;


// WEBPACK FOOTER //
// ./src/components/AdvancedFilter/CategoryFilter.jsx